import React, { ReactNode } from 'react';
import { breakpoints } from '../../../global/global-config';
import { Stack as SherpaStack, StackProps as SherpaStackProps } from '@bshgroup/component-stack';
import type { ResponsiveValue } from '@bshgroup/component-themes';
import type { CSSObject } from '@emotion/react';

export interface LinearLayoutProps {
  /**
   * Item layout orientation
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * Items to lay out
   */
  children: ReactNode;
  /**
   * Item alignment
   */
  align?: ResponsiveValue<CSSObject['alignItems']>;
  /**
   * Item justification
   */
  justify?: ResponsiveValue<CSSObject['justifyContent']>;
}

/**
 * The `LinearLayout` component is used to display content in a linear layout.
 */
export default function LinearLayout({
  orientation = 'vertical',
  children,
  ...props
}: LinearLayoutProps & Omit<Partial<SherpaStackProps>, keyof LinearLayoutProps>) {
  return (
    <SherpaStack
      direction={orientation}
      spacing={{
        [breakpoints.sm]: 'small-sm',
        [breakpoints.md]: 'small-md',
        [breakpoints.lg]: 'small-lg',
      }}
      {...props}
    >
      {children}
    </SherpaStack>
  );
}
